// extracted by mini-css-extract-plugin
export default {"text_shadow":"feed-summary-item_text_shadow__di-z-"};